(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['./ApiClient', './model/APiDocAdminLabelUpdate', './model/APiDocAdminLabelUpdateLabelUpdate', './model/APiDocAdminPriorityIndexUpdate', './model/APiDocAdminPriorityIndexUpdatePIUpdate', './model/ActiveWallpaperUpdate', './model/AdminModRequest', './model/ApiDocAdminModQuery', './model/ApiDocAdminModQueryResp', './model/ApiDocAppQueryRequest', './model/ApiDocContentModResp', './model/ApiDocCpSearchReq', './model/ApiDocDataWrapperContentProfileView', './model/ApiDocDataWrapperString', './model/ApiDocFavoriteQueryRequest', './model/ApiDocListFileResp', './model/ApiDocPersonalSearchReq', './model/ApiDocRecmdContentQueryRequest', './model/ApiDocRecmdLabelResp', './model/ApiDocSearchResult', './model/ApiDocStringList', './model/ApiDocWallpaperQueryRequest', './model/ApiDocWidgetQueryRequest', './model/App', './model/BlobLocation', './model/Category', './model/CategoryCreationRequest', './model/CategoryUpdateRequest', './model/CloudFileInfo', './model/CollaborationLocation', './model/ContentCreationResp', './model/ContentModPR', './model/ContentModeration', './model/ContentProfilePreviewsInfo', './model/ContentProfileView', './model/ContentShareRequest', './model/CpContentMetadata', './model/CreateFileRequest', './model/CreateFileResp', './model/CreatedResp', './model/DataWrapper', './model/DocCapabilitiesSetUpdate', './model/DocComponentTypeListUpdate', './model/DocCountryUpdate', './model/DocGradeListUpdate', './model/DocGradeSetUpdate', './model/DocLanguageUpdate', './model/DocLongUpdate', './model/DocResourceCategoryUpdate', './model/DocStringSetUpdate', './model/DocStringUpdate', './model/DocVersionUpdate', './model/ExtMetadata', './model/ExtSession', './model/ExtTransaction', './model/ExternalUpdates', './model/ExternalUrlRequest', './model/FavoriteUploadRequest', './model/FavoriteUploadResponse', './model/GetResourceResp', './model/GetShareLinkTypeResponse', './model/GetWidgetResp', './model/Grade', './model/ImportFileRequest', './model/IndexedContentProfileView', './model/InitProcessingRequest', './model/Metadata', './model/ModMetaPR', './model/ModMetadataResp', './model/ModelSmex', './model/Nothing', './model/PreviewData', './model/RecmdContentProfile', './model/RecmdContentResp', './model/RecmdLabel', './model/SearchResult', './model/SessionContentParam', './model/SessionContentUploadParam', './model/SessionCreationRequest', './model/SessionExternalUrlRequest', './model/SessionUpdateRequest', './model/SmexRequest', './model/StringArrayUpdate', './model/StringUpdate', './model/Transaction', './model/Update', './model/UrlInfo', './model/Version', './model/Wallpaper', './model/WallpaperUploadResponse', './model/Widget', './model/WidgetCreationResponse', './model/WidgetGetUpdatesResponse', './model/WidgetMetadataRequest', './model/WidgetPackage', './model/WidgetPackageMetadataUpdate', './model/WidgetRegisterRequest', './model/WidgetTemplate', './model/WidgetTemplateMetadata', './model/WidgetTemplateQueryResponse', './model/WidgetTemplateUpdateRequest', './model/WidgetUpdateMetadata', './model/WidgetUploadMetadata', './api/AdminadminportalApi', './api/AdminadminportalmodApi', './api/RecommendationscontentApi', './api/ResourcesApi', './api/ShareApi', './api/SmexApi', './api/TApi', './api/TransactionsApi', './api/VappstoreApi', './api/VcloudgdApi', './api/VcollaborationApi', './api/VcpApi', './api/VpersonalizationApi', './api/VsearchApi', './api/VsearchcpApi', './api/VsessionApi', './api/VwidgetsApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/APiDocAdminLabelUpdate'), require('./model/APiDocAdminLabelUpdateLabelUpdate'), require('./model/APiDocAdminPriorityIndexUpdate'), require('./model/APiDocAdminPriorityIndexUpdatePIUpdate'), require('./model/ActiveWallpaperUpdate'), require('./model/AdminModRequest'), require('./model/ApiDocAdminModQuery'), require('./model/ApiDocAdminModQueryResp'), require('./model/ApiDocAppQueryRequest'), require('./model/ApiDocContentModResp'), require('./model/ApiDocCpSearchReq'), require('./model/ApiDocDataWrapperContentProfileView'), require('./model/ApiDocDataWrapperString'), require('./model/ApiDocFavoriteQueryRequest'), require('./model/ApiDocListFileResp'), require('./model/ApiDocPersonalSearchReq'), require('./model/ApiDocRecmdContentQueryRequest'), require('./model/ApiDocRecmdLabelResp'), require('./model/ApiDocSearchResult'), require('./model/ApiDocStringList'), require('./model/ApiDocWallpaperQueryRequest'), require('./model/ApiDocWidgetQueryRequest'), require('./model/App'), require('./model/BlobLocation'), require('./model/Category'), require('./model/CategoryCreationRequest'), require('./model/CategoryUpdateRequest'), require('./model/CloudFileInfo'), require('./model/CollaborationLocation'), require('./model/ContentCreationResp'), require('./model/ContentModPR'), require('./model/ContentModeration'), require('./model/ContentProfilePreviewsInfo'), require('./model/ContentProfileView'), require('./model/ContentShareRequest'), require('./model/CpContentMetadata'), require('./model/CreateFileRequest'), require('./model/CreateFileResp'), require('./model/CreatedResp'), require('./model/DataWrapper'), require('./model/DocCapabilitiesSetUpdate'), require('./model/DocComponentTypeListUpdate'), require('./model/DocCountryUpdate'), require('./model/DocGradeListUpdate'), require('./model/DocGradeSetUpdate'), require('./model/DocLanguageUpdate'), require('./model/DocLongUpdate'), require('./model/DocResourceCategoryUpdate'), require('./model/DocStringSetUpdate'), require('./model/DocStringUpdate'), require('./model/DocVersionUpdate'), require('./model/ExtMetadata'), require('./model/ExtSession'), require('./model/ExtTransaction'), require('./model/ExternalUpdates'), require('./model/ExternalUrlRequest'), require('./model/FavoriteUploadRequest'), require('./model/FavoriteUploadResponse'), require('./model/GetResourceResp'), require('./model/GetShareLinkTypeResponse'), require('./model/GetWidgetResp'), require('./model/Grade'), require('./model/ImportFileRequest'), require('./model/IndexedContentProfileView'), require('./model/InitProcessingRequest'), require('./model/Metadata'), require('./model/ModMetaPR'), require('./model/ModMetadataResp'), require('./model/ModelSmex'), require('./model/Nothing'), require('./model/PreviewData'), require('./model/RecmdContentProfile'), require('./model/RecmdContentResp'), require('./model/RecmdLabel'), require('./model/SearchResult'), require('./model/SessionContentParam'), require('./model/SessionContentUploadParam'), require('./model/SessionCreationRequest'), require('./model/SessionExternalUrlRequest'), require('./model/SessionUpdateRequest'), require('./model/SmexRequest'), require('./model/StringArrayUpdate'), require('./model/StringUpdate'), require('./model/Transaction'), require('./model/Update'), require('./model/UrlInfo'), require('./model/Version'), require('./model/Wallpaper'), require('./model/WallpaperUploadResponse'), require('./model/Widget'), require('./model/WidgetCreationResponse'), require('./model/WidgetGetUpdatesResponse'), require('./model/WidgetMetadataRequest'), require('./model/WidgetPackage'), require('./model/WidgetPackageMetadataUpdate'), require('./model/WidgetRegisterRequest'), require('./model/WidgetTemplate'), require('./model/WidgetTemplateMetadata'), require('./model/WidgetTemplateQueryResponse'), require('./model/WidgetTemplateUpdateRequest'), require('./model/WidgetUpdateMetadata'), require('./model/WidgetUploadMetadata'), require('./api/AdminadminportalApi'), require('./api/AdminadminportalmodApi'), require('./api/RecommendationscontentApi'), require('./api/ResourcesApi'), require('./api/ShareApi'), require('./api/SmexApi'), require('./api/TApi'), require('./api/TransactionsApi'), require('./api/VappstoreApi'), require('./api/VcloudgdApi'), require('./api/VcollaborationApi'), require('./api/VcpApi'), require('./api/VpersonalizationApi'), require('./api/VsearchApi'), require('./api/VsearchcpApi'), require('./api/VsessionApi'), require('./api/VwidgetsApi'));
  }
}(function(ApiClient, APiDocAdminLabelUpdate, APiDocAdminLabelUpdateLabelUpdate, APiDocAdminPriorityIndexUpdate, APiDocAdminPriorityIndexUpdatePIUpdate, ActiveWallpaperUpdate, AdminModRequest, ApiDocAdminModQuery, ApiDocAdminModQueryResp, ApiDocAppQueryRequest, ApiDocContentModResp, ApiDocCpSearchReq, ApiDocDataWrapperContentProfileView, ApiDocDataWrapperString, ApiDocFavoriteQueryRequest, ApiDocListFileResp, ApiDocPersonalSearchReq, ApiDocRecmdContentQueryRequest, ApiDocRecmdLabelResp, ApiDocSearchResult, ApiDocStringList, ApiDocWallpaperQueryRequest, ApiDocWidgetQueryRequest, App, BlobLocation, Category, CategoryCreationRequest, CategoryUpdateRequest, CloudFileInfo, CollaborationLocation, ContentCreationResp, ContentModPR, ContentModeration, ContentProfilePreviewsInfo, ContentProfileView, ContentShareRequest, CpContentMetadata, CreateFileRequest, CreateFileResp, CreatedResp, DataWrapper, DocCapabilitiesSetUpdate, DocComponentTypeListUpdate, DocCountryUpdate, DocGradeListUpdate, DocGradeSetUpdate, DocLanguageUpdate, DocLongUpdate, DocResourceCategoryUpdate, DocStringSetUpdate, DocStringUpdate, DocVersionUpdate, ExtMetadata, ExtSession, ExtTransaction, ExternalUpdates, ExternalUrlRequest, FavoriteUploadRequest, FavoriteUploadResponse, GetResourceResp, GetShareLinkTypeResponse, GetWidgetResp, Grade, ImportFileRequest, IndexedContentProfileView, InitProcessingRequest, Metadata, ModMetaPR, ModMetadataResp, ModelSmex, Nothing, PreviewData, RecmdContentProfile, RecmdContentResp, RecmdLabel, SearchResult, SessionContentParam, SessionContentUploadParam, SessionCreationRequest, SessionExternalUrlRequest, SessionUpdateRequest, SmexRequest, StringArrayUpdate, StringUpdate, Transaction, Update, UrlInfo, Version, Wallpaper, WallpaperUploadResponse, Widget, WidgetCreationResponse, WidgetGetUpdatesResponse, WidgetMetadataRequest, WidgetPackage, WidgetPackageMetadataUpdate, WidgetRegisterRequest, WidgetTemplate, WidgetTemplateMetadata, WidgetTemplateQueryResponse, WidgetTemplateUpdateRequest, WidgetUpdateMetadata, WidgetUploadMetadata, AdminadminportalApi, AdminadminportalmodApi, RecommendationscontentApi, ResourcesApi, ShareApi, SmexApi, TApi, TransactionsApi, VappstoreApi, VcloudgdApi, VcollaborationApi, VcpApi, VpersonalizationApi, VsearchApi, VsearchcpApi, VsessionApi, VwidgetsApi) {
  'use strict';

  /**
   * Client library of smart-cs-v2-sdk.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var SmartCsV2Sdk = require('./index'); // See note below*.
   * var xxxSvc = new SmartCsV2Sdk.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new SmartCsV2Sdk.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['./index'], function(){...}) and put the application logic within the
   * callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new SmartCsV2Sdk.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new SmartCsV2Sdk.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 2.0.624
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The APiDocAdminLabelUpdate model constructor.
     * @property {module:model/APiDocAdminLabelUpdate}
     */
    APiDocAdminLabelUpdate: APiDocAdminLabelUpdate,
    /**
     * The APiDocAdminLabelUpdateLabelUpdate model constructor.
     * @property {module:model/APiDocAdminLabelUpdateLabelUpdate}
     */
    APiDocAdminLabelUpdateLabelUpdate: APiDocAdminLabelUpdateLabelUpdate,
    /**
     * The APiDocAdminPriorityIndexUpdate model constructor.
     * @property {module:model/APiDocAdminPriorityIndexUpdate}
     */
    APiDocAdminPriorityIndexUpdate: APiDocAdminPriorityIndexUpdate,
    /**
     * The APiDocAdminPriorityIndexUpdatePIUpdate model constructor.
     * @property {module:model/APiDocAdminPriorityIndexUpdatePIUpdate}
     */
    APiDocAdminPriorityIndexUpdatePIUpdate: APiDocAdminPriorityIndexUpdatePIUpdate,
    /**
     * The ActiveWallpaperUpdate model constructor.
     * @property {module:model/ActiveWallpaperUpdate}
     */
    ActiveWallpaperUpdate: ActiveWallpaperUpdate,
    /**
     * The AdminModRequest model constructor.
     * @property {module:model/AdminModRequest}
     */
    AdminModRequest: AdminModRequest,
    /**
     * The ApiDocAdminModQuery model constructor.
     * @property {module:model/ApiDocAdminModQuery}
     */
    ApiDocAdminModQuery: ApiDocAdminModQuery,
    /**
     * The ApiDocAdminModQueryResp model constructor.
     * @property {module:model/ApiDocAdminModQueryResp}
     */
    ApiDocAdminModQueryResp: ApiDocAdminModQueryResp,
    /**
     * The ApiDocAppQueryRequest model constructor.
     * @property {module:model/ApiDocAppQueryRequest}
     */
    ApiDocAppQueryRequest: ApiDocAppQueryRequest,
    /**
     * The ApiDocContentModResp model constructor.
     * @property {module:model/ApiDocContentModResp}
     */
    ApiDocContentModResp: ApiDocContentModResp,
    /**
     * The ApiDocCpSearchReq model constructor.
     * @property {module:model/ApiDocCpSearchReq}
     */
    ApiDocCpSearchReq: ApiDocCpSearchReq,
    /**
     * The ApiDocDataWrapperContentProfileView model constructor.
     * @property {module:model/ApiDocDataWrapperContentProfileView}
     */
    ApiDocDataWrapperContentProfileView: ApiDocDataWrapperContentProfileView,
    /**
     * The ApiDocDataWrapperString model constructor.
     * @property {module:model/ApiDocDataWrapperString}
     */
    ApiDocDataWrapperString: ApiDocDataWrapperString,
    /**
     * The ApiDocFavoriteQueryRequest model constructor.
     * @property {module:model/ApiDocFavoriteQueryRequest}
     */
    ApiDocFavoriteQueryRequest: ApiDocFavoriteQueryRequest,
    /**
     * The ApiDocListFileResp model constructor.
     * @property {module:model/ApiDocListFileResp}
     */
    ApiDocListFileResp: ApiDocListFileResp,
    /**
     * The ApiDocPersonalSearchReq model constructor.
     * @property {module:model/ApiDocPersonalSearchReq}
     */
    ApiDocPersonalSearchReq: ApiDocPersonalSearchReq,
    /**
     * The ApiDocRecmdContentQueryRequest model constructor.
     * @property {module:model/ApiDocRecmdContentQueryRequest}
     */
    ApiDocRecmdContentQueryRequest: ApiDocRecmdContentQueryRequest,
    /**
     * The ApiDocRecmdLabelResp model constructor.
     * @property {module:model/ApiDocRecmdLabelResp}
     */
    ApiDocRecmdLabelResp: ApiDocRecmdLabelResp,
    /**
     * The ApiDocSearchResult model constructor.
     * @property {module:model/ApiDocSearchResult}
     */
    ApiDocSearchResult: ApiDocSearchResult,
    /**
     * The ApiDocStringList model constructor.
     * @property {module:model/ApiDocStringList}
     */
    ApiDocStringList: ApiDocStringList,
    /**
     * The ApiDocWallpaperQueryRequest model constructor.
     * @property {module:model/ApiDocWallpaperQueryRequest}
     */
    ApiDocWallpaperQueryRequest: ApiDocWallpaperQueryRequest,
    /**
     * The ApiDocWidgetQueryRequest model constructor.
     * @property {module:model/ApiDocWidgetQueryRequest}
     */
    ApiDocWidgetQueryRequest: ApiDocWidgetQueryRequest,
    /**
     * The App model constructor.
     * @property {module:model/App}
     */
    App: App,
    /**
     * The BlobLocation model constructor.
     * @property {module:model/BlobLocation}
     */
    BlobLocation: BlobLocation,
    /**
     * The Category model constructor.
     * @property {module:model/Category}
     */
    Category: Category,
    /**
     * The CategoryCreationRequest model constructor.
     * @property {module:model/CategoryCreationRequest}
     */
    CategoryCreationRequest: CategoryCreationRequest,
    /**
     * The CategoryUpdateRequest model constructor.
     * @property {module:model/CategoryUpdateRequest}
     */
    CategoryUpdateRequest: CategoryUpdateRequest,
    /**
     * The CloudFileInfo model constructor.
     * @property {module:model/CloudFileInfo}
     */
    CloudFileInfo: CloudFileInfo,
    /**
     * The CollaborationLocation model constructor.
     * @property {module:model/CollaborationLocation}
     */
    CollaborationLocation: CollaborationLocation,
    /**
     * The ContentCreationResp model constructor.
     * @property {module:model/ContentCreationResp}
     */
    ContentCreationResp: ContentCreationResp,
    /**
     * The ContentModPR model constructor.
     * @property {module:model/ContentModPR}
     */
    ContentModPR: ContentModPR,
    /**
     * The ContentModeration model constructor.
     * @property {module:model/ContentModeration}
     */
    ContentModeration: ContentModeration,
    /**
     * The ContentProfilePreviewsInfo model constructor.
     * @property {module:model/ContentProfilePreviewsInfo}
     */
    ContentProfilePreviewsInfo: ContentProfilePreviewsInfo,
    /**
     * The ContentProfileView model constructor.
     * @property {module:model/ContentProfileView}
     */
    ContentProfileView: ContentProfileView,
    /**
     * The ContentShareRequest model constructor.
     * @property {module:model/ContentShareRequest}
     */
    ContentShareRequest: ContentShareRequest,
    /**
     * The CpContentMetadata model constructor.
     * @property {module:model/CpContentMetadata}
     */
    CpContentMetadata: CpContentMetadata,
    /**
     * The CreateFileRequest model constructor.
     * @property {module:model/CreateFileRequest}
     */
    CreateFileRequest: CreateFileRequest,
    /**
     * The CreateFileResp model constructor.
     * @property {module:model/CreateFileResp}
     */
    CreateFileResp: CreateFileResp,
    /**
     * The CreatedResp model constructor.
     * @property {module:model/CreatedResp}
     */
    CreatedResp: CreatedResp,
    /**
     * The DataWrapper model constructor.
     * @property {module:model/DataWrapper}
     */
    DataWrapper: DataWrapper,
    /**
     * The DocCapabilitiesSetUpdate model constructor.
     * @property {module:model/DocCapabilitiesSetUpdate}
     */
    DocCapabilitiesSetUpdate: DocCapabilitiesSetUpdate,
    /**
     * The DocComponentTypeListUpdate model constructor.
     * @property {module:model/DocComponentTypeListUpdate}
     */
    DocComponentTypeListUpdate: DocComponentTypeListUpdate,
    /**
     * The DocCountryUpdate model constructor.
     * @property {module:model/DocCountryUpdate}
     */
    DocCountryUpdate: DocCountryUpdate,
    /**
     * The DocGradeListUpdate model constructor.
     * @property {module:model/DocGradeListUpdate}
     */
    DocGradeListUpdate: DocGradeListUpdate,
    /**
     * The DocGradeSetUpdate model constructor.
     * @property {module:model/DocGradeSetUpdate}
     */
    DocGradeSetUpdate: DocGradeSetUpdate,
    /**
     * The DocLanguageUpdate model constructor.
     * @property {module:model/DocLanguageUpdate}
     */
    DocLanguageUpdate: DocLanguageUpdate,
    /**
     * The DocLongUpdate model constructor.
     * @property {module:model/DocLongUpdate}
     */
    DocLongUpdate: DocLongUpdate,
    /**
     * The DocResourceCategoryUpdate model constructor.
     * @property {module:model/DocResourceCategoryUpdate}
     */
    DocResourceCategoryUpdate: DocResourceCategoryUpdate,
    /**
     * The DocStringSetUpdate model constructor.
     * @property {module:model/DocStringSetUpdate}
     */
    DocStringSetUpdate: DocStringSetUpdate,
    /**
     * The DocStringUpdate model constructor.
     * @property {module:model/DocStringUpdate}
     */
    DocStringUpdate: DocStringUpdate,
    /**
     * The DocVersionUpdate model constructor.
     * @property {module:model/DocVersionUpdate}
     */
    DocVersionUpdate: DocVersionUpdate,
    /**
     * The ExtMetadata model constructor.
     * @property {module:model/ExtMetadata}
     */
    ExtMetadata: ExtMetadata,
    /**
     * The ExtSession model constructor.
     * @property {module:model/ExtSession}
     */
    ExtSession: ExtSession,
    /**
     * The ExtTransaction model constructor.
     * @property {module:model/ExtTransaction}
     */
    ExtTransaction: ExtTransaction,
    /**
     * The ExternalUpdates model constructor.
     * @property {module:model/ExternalUpdates}
     */
    ExternalUpdates: ExternalUpdates,
    /**
     * The ExternalUrlRequest model constructor.
     * @property {module:model/ExternalUrlRequest}
     */
    ExternalUrlRequest: ExternalUrlRequest,
    /**
     * The FavoriteUploadRequest model constructor.
     * @property {module:model/FavoriteUploadRequest}
     */
    FavoriteUploadRequest: FavoriteUploadRequest,
    /**
     * The FavoriteUploadResponse model constructor.
     * @property {module:model/FavoriteUploadResponse}
     */
    FavoriteUploadResponse: FavoriteUploadResponse,
    /**
     * The GetResourceResp model constructor.
     * @property {module:model/GetResourceResp}
     */
    GetResourceResp: GetResourceResp,
    /**
     * The GetShareLinkTypeResponse model constructor.
     * @property {module:model/GetShareLinkTypeResponse}
     */
    GetShareLinkTypeResponse: GetShareLinkTypeResponse,
    /**
     * The GetWidgetResp model constructor.
     * @property {module:model/GetWidgetResp}
     */
    GetWidgetResp: GetWidgetResp,
    /**
     * The Grade model constructor.
     * @property {module:model/Grade}
     */
    Grade: Grade,
    /**
     * The ImportFileRequest model constructor.
     * @property {module:model/ImportFileRequest}
     */
    ImportFileRequest: ImportFileRequest,
    /**
     * The IndexedContentProfileView model constructor.
     * @property {module:model/IndexedContentProfileView}
     */
    IndexedContentProfileView: IndexedContentProfileView,
    /**
     * The InitProcessingRequest model constructor.
     * @property {module:model/InitProcessingRequest}
     */
    InitProcessingRequest: InitProcessingRequest,
    /**
     * The Metadata model constructor.
     * @property {module:model/Metadata}
     */
    Metadata: Metadata,
    /**
     * The ModMetaPR model constructor.
     * @property {module:model/ModMetaPR}
     */
    ModMetaPR: ModMetaPR,
    /**
     * The ModMetadataResp model constructor.
     * @property {module:model/ModMetadataResp}
     */
    ModMetadataResp: ModMetadataResp,
    /**
     * The ModelSmex model constructor.
     * @property {module:model/ModelSmex}
     */
    ModelSmex: ModelSmex,
    /**
     * The Nothing model constructor.
     * @property {module:model/Nothing}
     */
    Nothing: Nothing,
    /**
     * The PreviewData model constructor.
     * @property {module:model/PreviewData}
     */
    PreviewData: PreviewData,
    /**
     * The RecmdContentProfile model constructor.
     * @property {module:model/RecmdContentProfile}
     */
    RecmdContentProfile: RecmdContentProfile,
    /**
     * The RecmdContentResp model constructor.
     * @property {module:model/RecmdContentResp}
     */
    RecmdContentResp: RecmdContentResp,
    /**
     * The RecmdLabel model constructor.
     * @property {module:model/RecmdLabel}
     */
    RecmdLabel: RecmdLabel,
    /**
     * The SearchResult model constructor.
     * @property {module:model/SearchResult}
     */
    SearchResult: SearchResult,
    /**
     * The SessionContentParam model constructor.
     * @property {module:model/SessionContentParam}
     */
    SessionContentParam: SessionContentParam,
    /**
     * The SessionContentUploadParam model constructor.
     * @property {module:model/SessionContentUploadParam}
     */
    SessionContentUploadParam: SessionContentUploadParam,
    /**
     * The SessionCreationRequest model constructor.
     * @property {module:model/SessionCreationRequest}
     */
    SessionCreationRequest: SessionCreationRequest,
    /**
     * The SessionExternalUrlRequest model constructor.
     * @property {module:model/SessionExternalUrlRequest}
     */
    SessionExternalUrlRequest: SessionExternalUrlRequest,
    /**
     * The SessionUpdateRequest model constructor.
     * @property {module:model/SessionUpdateRequest}
     */
    SessionUpdateRequest: SessionUpdateRequest,
    /**
     * The SmexRequest model constructor.
     * @property {module:model/SmexRequest}
     */
    SmexRequest: SmexRequest,
    /**
     * The StringArrayUpdate model constructor.
     * @property {module:model/StringArrayUpdate}
     */
    StringArrayUpdate: StringArrayUpdate,
    /**
     * The StringUpdate model constructor.
     * @property {module:model/StringUpdate}
     */
    StringUpdate: StringUpdate,
    /**
     * The Transaction model constructor.
     * @property {module:model/Transaction}
     */
    Transaction: Transaction,
    /**
     * The Update model constructor.
     * @property {module:model/Update}
     */
    Update: Update,
    /**
     * The UrlInfo model constructor.
     * @property {module:model/UrlInfo}
     */
    UrlInfo: UrlInfo,
    /**
     * The Version model constructor.
     * @property {module:model/Version}
     */
    Version: Version,
    /**
     * The Wallpaper model constructor.
     * @property {module:model/Wallpaper}
     */
    Wallpaper: Wallpaper,
    /**
     * The WallpaperUploadResponse model constructor.
     * @property {module:model/WallpaperUploadResponse}
     */
    WallpaperUploadResponse: WallpaperUploadResponse,
    /**
     * The Widget model constructor.
     * @property {module:model/Widget}
     */
    Widget: Widget,
    /**
     * The WidgetCreationResponse model constructor.
     * @property {module:model/WidgetCreationResponse}
     */
    WidgetCreationResponse: WidgetCreationResponse,
    /**
     * The WidgetGetUpdatesResponse model constructor.
     * @property {module:model/WidgetGetUpdatesResponse}
     */
    WidgetGetUpdatesResponse: WidgetGetUpdatesResponse,
    /**
     * The WidgetMetadataRequest model constructor.
     * @property {module:model/WidgetMetadataRequest}
     */
    WidgetMetadataRequest: WidgetMetadataRequest,
    /**
     * The WidgetPackage model constructor.
     * @property {module:model/WidgetPackage}
     */
    WidgetPackage: WidgetPackage,
    /**
     * The WidgetPackageMetadataUpdate model constructor.
     * @property {module:model/WidgetPackageMetadataUpdate}
     */
    WidgetPackageMetadataUpdate: WidgetPackageMetadataUpdate,
    /**
     * The WidgetRegisterRequest model constructor.
     * @property {module:model/WidgetRegisterRequest}
     */
    WidgetRegisterRequest: WidgetRegisterRequest,
    /**
     * The WidgetTemplate model constructor.
     * @property {module:model/WidgetTemplate}
     */
    WidgetTemplate: WidgetTemplate,
    /**
     * The WidgetTemplateMetadata model constructor.
     * @property {module:model/WidgetTemplateMetadata}
     */
    WidgetTemplateMetadata: WidgetTemplateMetadata,
    /**
     * The WidgetTemplateQueryResponse model constructor.
     * @property {module:model/WidgetTemplateQueryResponse}
     */
    WidgetTemplateQueryResponse: WidgetTemplateQueryResponse,
    /**
     * The WidgetTemplateUpdateRequest model constructor.
     * @property {module:model/WidgetTemplateUpdateRequest}
     */
    WidgetTemplateUpdateRequest: WidgetTemplateUpdateRequest,
    /**
     * The WidgetUpdateMetadata model constructor.
     * @property {module:model/WidgetUpdateMetadata}
     */
    WidgetUpdateMetadata: WidgetUpdateMetadata,
    /**
     * The WidgetUploadMetadata model constructor.
     * @property {module:model/WidgetUploadMetadata}
     */
    WidgetUploadMetadata: WidgetUploadMetadata,
    /**
     * The AdminadminportalApi service constructor.
     * @property {module:api/AdminadminportalApi}
     */
    AdminadminportalApi: AdminadminportalApi,
    /**
     * The AdminadminportalmodApi service constructor.
     * @property {module:api/AdminadminportalmodApi}
     */
    AdminadminportalmodApi: AdminadminportalmodApi,
    /**
     * The RecommendationscontentApi service constructor.
     * @property {module:api/RecommendationscontentApi}
     */
    RecommendationscontentApi: RecommendationscontentApi,
    /**
     * The ResourcesApi service constructor.
     * @property {module:api/ResourcesApi}
     */
    ResourcesApi: ResourcesApi,
    /**
     * The ShareApi service constructor.
     * @property {module:api/ShareApi}
     */
    ShareApi: ShareApi,
    /**
     * The SmexApi service constructor.
     * @property {module:api/SmexApi}
     */
    SmexApi: SmexApi,
    /**
     * The TApi service constructor.
     * @property {module:api/TApi}
     */
    TApi: TApi,
    /**
     * The TransactionsApi service constructor.
     * @property {module:api/TransactionsApi}
     */
    TransactionsApi: TransactionsApi,
    /**
     * The VappstoreApi service constructor.
     * @property {module:api/VappstoreApi}
     */
    VappstoreApi: VappstoreApi,
    /**
     * The VcloudgdApi service constructor.
     * @property {module:api/VcloudgdApi}
     */
    VcloudgdApi: VcloudgdApi,
    /**
     * The VcollaborationApi service constructor.
     * @property {module:api/VcollaborationApi}
     */
    VcollaborationApi: VcollaborationApi,
    /**
     * The VcpApi service constructor.
     * @property {module:api/VcpApi}
     */
    VcpApi: VcpApi,
    /**
     * The VpersonalizationApi service constructor.
     * @property {module:api/VpersonalizationApi}
     */
    VpersonalizationApi: VpersonalizationApi,
    /**
     * The VsearchApi service constructor.
     * @property {module:api/VsearchApi}
     */
    VsearchApi: VsearchApi,
    /**
     * The VsearchcpApi service constructor.
     * @property {module:api/VsearchcpApi}
     */
    VsearchcpApi: VsearchcpApi,
    /**
     * The VsessionApi service constructor.
     * @property {module:api/VsessionApi}
     */
    VsessionApi: VsessionApi,
    /**
     * The VwidgetsApi service constructor.
     * @property {module:api/VwidgetsApi}
     */
    VwidgetsApi: VwidgetsApi
  };

  return exports;
}));
